import { Button } from "../components/Button";
import { PageContainer, PageContent } from "../components/PageContainer";
import { TitleBar } from "../components/TitleBar";
import { tMsg } from "../components/ToastNotifications";
import apiAgent from "../api/apiAgent";
import { changesSchema } from "../components/Publishing/atoms";
import { useAtomValue } from "jotai";
import { userAtom } from "../atoms";
import { AxiosResponse } from "axios";
import { addAnyNewPublishData } from "../components/Publishing/utils";
import { Link } from "react-router-dom";
import { HomePublishSection } from "../components/Publishing";

const SectionCard = ({ children }: { children: React.ReactNode }) => (
  <div className="w-full bg-black/10 p-8 flex flex-col gap-4">{children}</div>
);

const Home = (): JSX.Element => {
  const user = useAtomValue(userAtom);

  return (
    <PageContainer>
      <PageContent className="flex flex-col gap-4">
        <TitleBar title={`Welcome${" " + user?.username}!`} />
        <SectionCard>
          <div className="font-bold">Tour Website</div>
          <div className="text-sm">
            The Explore Old Dubbo Gaol website allows visitors to explore points
            of interest on a map of the Gaol, and find out more about the Gaol.
            Content can be edited by clicking on the different sections below.
          </div>
          <div className="flex gap-2">
            <Link to="/m/featureNodes">
              <Button>Map</Button>
            </Link>
            <Link to="/m/tags">
              <Button>Filters</Button>
            </Link>
            <Link to="/m/resources">
              <Button>Resources Slides</Button>
            </Link>
            <Link to="/m/abouts">
              <Button>About Slides</Button>
            </Link>
            <Link to="/si/welcomepopup">
              <Button>Welcome Popup</Button>
            </Link>
          </div>
          <HomePublishSection appGroup="featureNodes" />
        </SectionCard>
        <SectionCard>
          <div className="font-bold">Gallows Interactive</div>
          <div className="text-sm">
            The Gallows Gallery interactive allows visitors to explore
            information about people who were condemned at Old Dubbo Gaol.
            Content can be edited by clicking on the different sections below
          </div>
          <div className="flex gap-2">
            <Link to="/si/screensaver">
              <Button>Screensaver</Button>
            </Link>
            <Link to="/m/people">
              <Button>People</Button>
            </Link>
          </div>
          <HomePublishSection appGroup="gallows" />
        </SectionCard>
      </PageContent>
    </PageContainer>
  );
};

export default Home;
